import { useCfarStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { PageLoadingScreen } from "@b2bportal/core-ui";

import defaultStyles from "./AirCfarExerciseLoadingScreen.module.scss";

export const AirCfarExerciseLoadingScreen = (props: {
  title: string;
  subtitle?: string;
}) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseLoadingScreen,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseLoadingScreen
  );

  const { title } = props;

  return (
    <div className={block}>
      <PageLoadingScreen
        className={cn("loading-popup")}
        isLoading
        text={title}
      />
    </div>
  );
};
